// DES2 WS-14: the Knowledge page copy in this language (see ui/i18n/ns/knowledge-pages.ts).
import type { KnowledgePagesCopy } from '../ns/knowledge-pages';

const es: KnowledgePagesCopy = {
  knowledgePage: 'Página de conocimiento',
  knowledgePages: 'Páginas de conocimiento',
  featureOffTitle: 'Las páginas de conocimiento no están activadas en este espacio de trabajo.',
  featureOffBody: 'El contexto y las fuentes de la empresa siguen en Conocimiento.',
  loadingPage: 'Cargando página…',
  loadingSuggestion: 'Cargando sugerencia…',
  cancel: 'Cancelar',
  tryAgain: 'Reintentar',
  everyoneIn: 'Todos en {company}',
  yourCompany: 'tu empresa',
  revision: 'Revisión {n}',
  openRevision: 'Abrir revisión {n}',
  pageCount: 'one:página|many:páginas|other:páginas',
  topicCount: 'one:tema|many:temas|other:temas',
  sectionCount: 'one:sección|many:secciones|other:secciones',
  lineCount: 'one:línea|many:líneas|other:líneas',
  documentCount: 'one:documento|many:documentos|other:documentos',
  changeCount: 'one:cambio|many:cambios|other:cambios',
  newPageCount: 'one:página nueva|many:páginas nuevas|other:páginas nuevas',
  changedPageCount: 'one:página modificada|many:páginas modificadas|other:páginas modificadas',
  otherSectionCount: 'one:sección más|many:secciones más|other:secciones más',
  characterCount: 'one:carácter|many:caracteres|other:caracteres',
  diffStats: '{sections} con cambios · añadidas: {added} · eliminadas: {removed}',
  diffMatchesBase: 'El texto propuesto coincide con la revisión base.',
  diffIntroduction: 'Introducción',
  diffOtherUnchanged: '{sections} sin cambios.',
  timeJustNow: 'justo ahora',
  originImportedFrom: 'Importado de {path}',
  originImportedFromCommit: 'Importado de {path} @ {commit}',
  authorityApprovedInPoneva: 'Aprobado en Poneva',
  authorityImported: 'Importado',
  authorityInRepository: '{canonicality} en el repositorio',
  authorityVerified: 'verificado el {date}',
  authorRepositoryImport: 'Importación del repositorio',
  authorSuggestedInChat: 'Sugerido en el chat',
  authorSuggestedInChatWith: 'Sugerido en el chat con {name}',
  authorSuggestedBy: 'Sugerido por {name}',
  authorSuggestedByApp: 'Sugerido por una app conectada',
  authorSuggestedByColleague: 'Sugerido por un compañero',
  authorSuggestedByYou: 'Sugerido por ti',
  authorSuggestedOnBehalf: 'Sugerido por {app} en nombre de {name}',
  authorSuggestedByAppOnBehalf: 'Sugerido por una app conectada en nombre de {name}',
  authorSuggestedAndApproved: 'Sugerido y aprobado por {name}',
  approverApprovedBy: 'aprobado por {name}',
  approverAppliedBy: 'aplicado por {name}',
  kindCreatePage: 'Página nueva',
  kindUpdatePage: 'Cambio propuesto',
  kindArchivePage: 'Archivado',
  statusConflict: 'Conflicto · la página cambió',
  statusPending: 'Pendiente de revisión',
  statusApproved: 'Aprobado',
  statusRejected: 'Descartado',
  statusWithdrawn: 'Retirado',
  statusSuperseded: 'Reemplazado',
  errRevisionConflict: 'Esta página cambió mientras la revisabas.',
  errProposalChanged:
    'Esta sugerencia cambió mientras la revisabas. Revisa la versión más reciente antes de decidir.',
  errPublishRequired:
    'Solo las personas con permiso de publicación en la empresa pueden aprobar cambios en el conocimiento o importar páginas.',
  errProposalLimit:
    'Tu empresa ya tiene 200 sugerencias pendientes de revisión. Revisa algunas antes de sugerir más.',
  errAuthorLimit:
    'Ya tienes 50 sugerencias pendientes de revisión. Espera a que se decidan algunas, o retira algunas, antes de sugerir más.',
  errImportProposalLimit:
    'Esta importación añadiría más páginas modificadas para revisar de las que caben en la cola de revisión de tu empresa (200 como máximo). Decide algunas sugerencias en Para revisar y vuelve a aplicarla.',
  errImportChanged:
    'Esta importación no es la que revisaste. Ábrela de nuevo y revísala antes de aplicarla.',
  errImportItemNotFound: 'Este documento ya no forma parte de la importación.',
  errIdempotencyConflict:
    'Esta sugerencia ya se envió con otro contenido. Recarga e inténtalo de nuevo.',
  errImportHashMismatch:
    'Un archivo de esta instantánea no coincide con su suma de comprobación registrada. Vuelve a crear la instantánea e inténtalo de nuevo.',
  errImportAlreadyApplied: 'Esta importación ya se aplicó.',
  errImportDiscarded: 'Esta importación se descartó. Vuelve a elegir el archivo de la instantánea.',
  errImportDuplicateItem:
    'Esta instantánea incluye el mismo documento dos veces. Vuelve a crear la instantánea.',
  errInvalidImport:
    'Poneva no pudo aceptar esta instantánea. Vuelve a crearla con el script de instantáneas e inténtalo de nuevo.',
  errInvalidInput: 'Poneva no pudo aceptar estos datos. Revisa los campos e inténtalo de nuevo.',
  errImportLimit:
    'Hay demasiadas importaciones preparadas sin aplicar. Aplica o descarta algunas antes de preparar otra.',
  errPageTooLarge: 'Una página ocupa más de 256 KB. Divídela en páginas más pequeñas.',
  errTooManySections: 'Una página tiene más de 2000 encabezados. Divídela en páginas más pequeñas.',
  errPageLimit: 'Tu empresa ha alcanzado el límite de 2000 páginas de conocimiento.',
  errCollectionLimit: 'Tu empresa ha alcanzado el límite de 100 temas.',
  errProposalNotPending: 'Esta sugerencia ya se decidió. El estado que ves es el actual.',
  errRequesterRemoved:
    'La persona que sugirió esto ya no está en esta empresa, así que no se puede aprobar.',
  errRevisionAlreadyCurrent: 'Esa revisión ya es la actual.',
  errPageArchived:
    'Esta página se archivó mientras la revisabas. Vuelve a revisar la sugerencia antes de decidir.',
  errAlreadyArchived: 'Esta página ya está archivada.',
  errProposalForbidden: 'Solo quien sugirió esto puede retirarlo.',
  errUnavailable: 'Las páginas de conocimiento no están disponibles ahora mismo.',
  errTimeout: 'Poneva tardó demasiado en responder.',
  errItemTooLarge: '{path} ocupa más de 256 KB. Divídelo en páginas más pequeñas.',
  errItemTooManySections: '{path} tiene más de 2000 encabezados. Divídelo en páginas más pequeñas.',
  errItemHashMismatch:
    '{path} no coincide con su suma de comprobación registrada. Vuelve a crear la instantánea e inténtalo de nuevo.',
  errNoLongerAvailable: 'Este elemento ya no está disponible para ti.',
  errTooLargeToSend: 'Este archivo es demasiado grande para enviarlo.',
  cardChecking: 'Comprobando el estado…',
  cardNotAvailable: 'No disponible',
  cardStatusUnavailable: 'Estado no disponible',
  cardUnshowable: 'No se pudo mostrar este cambio de conocimiento sugerido.',
  cardEyebrow: 'Cambio de conocimiento sugerido',
  cardLabel: 'Cambio de conocimiento sugerido · {title}',
  cardMissing: 'Esta sugerencia ya no está disponible para ti.',
  cardUnknown:
    'No pudimos comprobar en qué punto está esta sugerencia. Abre la revisión para ver su estado.',
  cardCheckAgain: 'Volver a comprobar',
  cardReview: 'Revisar cambio',
  statusLineApproved: 'Conocimiento aprobado',
  readyCount: 'one:listo para buscar|many:listos para buscar|other:listos para buscar',
  preparingCount: 'one:en preparación|many:en preparación|other:en preparación',
  attentionCount: 'one:requiere atención|many:requieren atención|other:requieren atención',
  topicsExplore: 'Explorar un tema',
  topicsAllPages: 'Todas las páginas',
  topicsOpenPages: 'Abrir Páginas',
  topicsEmpty:
    'Aún no hay páginas aprobadas. Las páginas recogen el conocimiento extenso de la empresa con todo su historial de revisiones.',
  reviewsTitle: 'Cambios de página sugeridos',
  reviewsTitleMine: 'Tus cambios de página sugeridos',
  reviewsIntro:
    'Cada sugerencia es una revisión candidata completa, con su motivo y su evidencia. Nada cambia hasta que apruebas esa revisión exacta.',
  reviewsIntroMine:
    'Tus sugerencias esperan aquí hasta que una persona con permiso de publicación en la empresa las revise. Hasta entonces, las páginas no cambian.',
  loadPagesFailed: 'No pudimos cargar las páginas de conocimiento.',
  loadProposalsFailed: 'No pudimos cargar los cambios de página sugeridos.',
  loadMoreFailed: 'No pudimos cargar más páginas.',
  otherPages: 'Otras páginas',
  loadTopicFailed: 'No pudimos cargar este tema.',
  revisionShort: 'r{n}',
  updatedOn: 'Actualizado el {date}',
  emptyTitle: 'Aún no hay páginas de conocimiento.',
  emptyBody:
    'Las páginas recogen el conocimiento aprobado y extenso de tu empresa —orientación, decisiones y formas de trabajar— y conservan cada revisión. Importa desde una instantánea del repositorio o empieza una página en el chat; un publicador aprueba cada página antes de que cuente como conocimiento de la empresa.',
  importFromSnapshot: 'Importar desde una instantánea del repositorio',
  startInChat: 'Empezar una página en el chat',
  startInChatPrompt:
    'Ayúdame a empezar una página de conocimiento para nuestra empresa. Pregúntame qué debe cubrir y no inventes contenido. Seguirá siendo una sugerencia hasta que una persona con permiso de publicación en la empresa la apruebe.',
  loadingPages: 'Cargando páginas de conocimiento…',
  filterLabel: 'Filtrar páginas por título',
  filterPlaceholder: 'Filtrar páginas',
  importButton: 'Importar',
  showingTopic: 'Mostrando {topic}',
  showAllTopics: 'Mostrar todos los temas',
  loadingTopic: 'Cargando este tema…',
  noMatch: 'Ninguna página coincide con «{filter}».',
  topicNoPages: 'Aún no hay páginas aprobadas en este tema.',
  loading: 'Cargando…',
  loadMore: 'Cargar más páginas',
  metaApproved: 'aprobado el {date}',
  metaRepositoryAuthoritative: 'el repositorio sigue siendo la fuente de referencia',
  loadPageFailed: 'No pudimos cargar esta página.',
  loadHistoryFailed: 'No pudimos cargar el historial de revisiones.',
  outlineLabel: 'Secciones de la página',
  outlineToggle: 'En esta página',
  loadingHistory: 'Cargando el historial de revisiones…',
  historyLabel: 'Historial de revisiones',
  historyIntro:
    'Se conserva cada revisión aprobada. Restaurar una anterior crea una sugerencia para revisar; nunca borra las revisiones posteriores.',
  historyCurrent: 'Actual',
  historyViewing: 'Viendo',
  historyView: 'Ver',
  historyViewAria: 'Ver la revisión {n}',
  restoreAria: 'Restaurar como sugerencia: revisión {n}',
  restoreCreating: 'Creando sugerencia…',
  restore: 'Restaurar como sugerencia',
  restoreUnconfirmed:
    'No pudimos confirmar que se creara la sugerencia. Comprueba Para revisar antes de volver a intentarlo.',
  editTooLarge:
    'Esta página ocupa más de 256 KB. Divídela en páginas más pequeñas antes de sugerirla.',
  editConflict:
    'Esta página cambió mientras la editabas. Copia tu texto, abre la revisión más reciente y vuelve a sugerir el cambio.',
  editUnconfirmed:
    'No pudimos confirmar que se enviara tu sugerencia. Comprueba Para revisar antes de volver a enviarla.',
  editHeading: 'Sugerir un cambio',
  editIntro:
    'Estás editando la revisión {n}. Una persona con permiso de publicación en la empresa revisa el cambio exacto antes de que se convierta en la revisión {next}; hasta entonces, la página no cambia.',
  editOutdated:
    'Se aprobó una revisión más reciente mientras editabas. Copia tu texto y vuelve a empezar desde la revisión más reciente para no perder nada de lo que cambió.',
  editContentLabel: 'Contenido de la página (Markdown)',
  editReasonLabel: '¿Por qué este cambio?',
  editReasonPlaceholder: 'Qué ha cambiado y de dónde sale.',
  editSending: 'Enviando…',
  editSend: 'Enviar a revisión',
  editDiscardConfirm: '¿Descartar este cambio? No se ha enviado nada de lo que modificaste.',
  editNoChanges: 'Aún no hay cambios.',
  editNeedsContent: 'Una página necesita algo de contenido.',
  exportFailed: 'No pudimos exportar esta página. Inténtalo de nuevo.',
  askPagePrompt: 'Pregunta sobre la página de conocimiento «{title}» (revisión {n}, {link}):',
  askPageSectionPrompt:
    'Pregunta sobre la página de conocimiento «{title}» § {section} (revisión {n}, {link}):',
  pageMissingTitle: 'Esta página no está disponible.',
  pageMissingBody:
    'Puede que se haya archivado o que ya no tengas acceso al conocimiento de esta empresa.',
  pageArchived: 'Archivada',
  viewingRevisionCurrent: 'Estás viendo la revisión {n}; la revisión actual es la {current}.',
  viewingRevisionOld: 'Estás viendo la revisión {n}. No es la revisión actual.',
  openCurrent: 'Abrir la actual',
  archivedBanner:
    'Esta página está archivada. Ya no se usa para las respuestas; su historial se conserva.',
  pageViewsLabel: 'Vistas de la página',
  tabRead: 'Leer',
  tabHistory: 'Historial',
  unknownSection:
    'La sección enlazada no forma parte de esta revisión. Se muestra la página completa.',
  askAboutPage: 'Preguntar sobre esta página',
  exporting: 'Exportando…',
  exportMarkdown: 'Exportar Markdown',
  loadSuggestionFailed: 'No pudimos cargar esta sugerencia.',
  evidenceSource: 'Fuente',
  evidenceFact: 'Contexto de la empresa',
  evidenceResult: 'Trabajo guardado',
  evidenceUrl: 'Página web',
  evidenceDecision: 'Decisión',
  evidenceReference: 'Referencia',
  evidenceOpenPage: 'Abrir página de conocimiento',
  evidenceOpenSource: 'Abrir fuente',
  evidenceOpenFact: 'Abrir contexto de la empresa',
  evidenceOpenResult: 'Abrir trabajo guardado',
  evidenceOpenUrl: 'Abrir página web',
  evidenceOpenDecision: 'Abrir decisión',
  evidenceOpenReference: 'Abrir referencia',
  evidenceDecisionNote: 'Una decisión registrada. No hay nada que abrir en Poneva.',
  evidenceFactGone: 'Este contexto de la empresa ya no está guardado.',
  evidencePageNoRevision: 'Esta página no tiene ninguna revisión aprobada que abrir.',
  evidencePrivateExcerpt: 'Evidencia privada: solo se compartió el fragmento de arriba.',
  evidencePrivate: 'Evidencia privada: su contenido no se compartió contigo.',
  evidenceHeading: 'Evidencia',
  evidenceNone: 'No se adjuntó ninguna evidencia. Valora el motivo de arriba por sí solo.',
  changeAdded: 'Añadido',
  changeRemoved: 'Eliminado',
  changeChanged: 'Modificado',
  changeUnchanged: 'Sin cambios',
  moreLineCount: 'one:línea más|many:líneas más|other:líneas más',
  moreUnchangedLineCount:
    'one:línea más sin cambios|many:líneas más sin cambios|other:líneas más sin cambios',
  unchangedLineCount: 'one:línea sin cambios|many:líneas sin cambios|other:líneas sin cambios',
  skipAdded: '{lines} — en la revisión completa',
  skipRemoved: '{lines} de texto eliminado',
  cutUnchanged: '{lines}, sin mostrar',
  cutChanged: '{lines} sin mostrar ({changes}). Consúltalas en la revisión completa.',
  cutAddedRemoved: 'añadidas: {added}, eliminadas: {removed}',
  cutAdded: 'añadidas: {added}',
  cutRemoved: 'eliminadas: {removed}',
  lineAddedSr: 'Añadido:',
  lineRemovedSr: 'Eliminado:',
  noLinesAdded: 'Una sección nueva. Su texto está en la revisión completa de abajo.',
  noLinesRemoved: 'Esta sección se eliminaría de la página.',
  noLinesChanged: 'Esta sección cambia. Su texto está en la revisión completa de abajo.',
  diffHeading: 'Cambios',
  outcomeArchived: 'Archivada.',
  outcomeArchivedBody:
    '{title} ya no se usa para las respuestas y ha salido de la lista de páginas. Sus revisiones, esta sugerencia y la decisión se conservan en el historial de la página.',
  openArchivedPage: 'Abrir página archivada',
  outcomeApproved: 'Aprobada.',
  outcomeApprovedRevision: 'La revisión {n} es ahora la versión aprobada de {title}.',
  outcomeApprovedPlain: 'Esta sugerencia se aprobó.',
  outcomeRestored:
    'La página vuelve a estar en la lista de páginas y se usa de nuevo para las respuestas.',
  outcomeKept:
    'La sugerencia, la decisión y todas las revisiones anteriores se conservan en el historial de la página.',
  openPage: 'Abrir página',
  outcomeDismissed: 'Descartada.',
  outcomeWithdrawn: 'Retirada.',
  outcomeSuperseded: 'Reemplazada.',
  outcomeSupersededBody:
    'Una revisión, sugerencia o importación del repositorio más reciente dejó obsoleta esta sugerencia. Por sí sola no cambió nada.',
  outcomeUnchanged: 'La página no cambia.',
  approveNewPage: 'Aprobar página nueva',
  approveArchive: 'Aprobar archivado',
  approveRestoreRevision: 'Restaurar y aprobar la revisión {n}',
  approveRevision: 'Aprobar la revisión {n}',
  approveArchiveNote: 'Al aprobar, esta página se archiva para todos en {company}.',
  approvePublishNote: 'Al aprobar, esta revisión se publica para todos en {company}.',
  approvePublishEvidenceNote:
    'Al aprobar, esta revisión y los fragmentos de evidencia que se muestran arriba se publican para todos en {company}.',
  archivedTitle: 'Esta página está archivada.',
  alreadyArchivedBody:
    'Aprobarla no cambiaría nada, así que esta sugerencia solo se puede descartar.',
  archivedRestoreBody:
    'Al aprobarla se restaura: la página vuelve a la lista de páginas, a la búsqueda y a las respuestas con esta revisión.',
  staleRevisionAction: 'Comparar con la versión más reciente',
  staleProposalTitle: 'Esta sugerencia cambió mientras la revisabas.',
  staleProposalAction: 'Revisar la versión más reciente',
  staleArchivedTitle:
    'Esta página se archivó mientras la revisabas. Aprobar esta sugerencia la restauraría.',
  staleArchivedAction: 'Volver a revisar',
  suggestionMissingTitle: 'Esta sugerencia no está disponible.',
  suggestionMissingBody:
    'Puede que se haya retirado, o que sea de otra persona y no se haya enviado a revisión de la empresa.',
  decideUnconfirmed:
    'No pudimos confirmar tu decisión. El estado que ves es el más reciente de Poneva; compruébalo antes de volver a intentarlo.',
  decideFailed: 'No pudimos guardar tu decisión.',
  discussPrompt: 'Ayúdame a pulir el cambio de conocimiento sugerido para «{title}» ({link}).',
  conflictBody:
    'Esta sugerencia se escribió sobre la revisión {base}; la revisión actual es la {current}. Aprobarla sobrescribiría ese cambio, así que no se puede aprobar tal como está.',
  conflictBodyPlain:
    'Esta sugerencia se escribió sobre una revisión anterior, así que no se puede aprobar tal como está.',
  openLatest: 'Abrir la versión más reciente',
  reworkInChat: 'Rehacer en el chat',
  factReason: 'Motivo',
  factNoReason: 'No se indicó ningún motivo.',
  factAudience: 'Audiencia',
  factRevision: 'Revisión',
  revisionNew: 'Una página nueva, revisión 1',
  revisionArchiveAfter: 'Archivar después de la revisión {n}',
  revisionWrittenAgainst: 'Escrita sobre la revisión {base}; la revisión actual es la {current}',
  revisionCurrentToProposed: 'Revisión actual {base} → revisión propuesta {next}',
  revisionProposed: 'Revisión propuesta {next}',
  proposedPage: 'Página propuesta',
  archivingHeading: 'Qué hace el archivado',
  archivingBody:
    'La página deja de usarse para las respuestas y sale de la lista de páginas. Sus revisiones y esta decisión se conservan.',
  noComparison: 'No hay comparación por secciones disponible para esta sugerencia.',
  showComplete: 'Mostrar la revisión completa',
  approving: 'Aprobando…',
  dismissing: 'Descartando…',
  dismiss: 'Descartar',
  withdrawing: 'Retirando…',
  withdraw: 'Retirar',
  editInChat: 'Editar en el chat',
  waitingForPublisher:
    'Esperando la revisión de una persona con permiso de publicación en la empresa.',
  snapshotTooLarge: 'Esta instantánea ocupa más de 8 MB. Créala con menos documentos.',
  snapshotNotSnapshot:
    'Este archivo no es una instantánea de conocimiento. Elige el archivo JSON que generó el script de instantáneas.',
  snapshotEmpty: 'Esta instantánea no contiene documentos.',
  readDocumentFailed: 'No pudimos leer este documento. Inténtalo de nuevo.',
  readingDocument: 'Leyendo el documento…',
  hideText: 'Ocultar texto',
  readText: 'Leer texto',
  textOf: 'Texto de {title}',
  gitSnapshot: 'Instantánea de Git {commit}',
  repositorySnapshot: 'Instantánea del repositorio',
  importNewHeading: '{pages} · se aprueban al aplicar',
  importNewNote:
    'Cada una se publica como página aprobada para todos en {company}, sin más revisión. Lee cada una antes de aplicar.',
  importChangedHeading: '{pages} · para revisión',
  importChangedNote:
    'Cada una se convierte en un cambio sugerido. Su página solo cambia cuando un publicador lo aprueba en Para revisar, donde se ve qué cambió.',
  unchangedDocumentCount:
    'one:documento sin cambios|many:documentos sin cambios|other:documentos sin cambios',
  unchangedNote: 'Ya coinciden con sus páginas aprobadas. No se escribe nada para ellos.',
  stagedHeading: 'Preparada pero sin aplicar',
  excludedSummary: '{documents} fuera de esta instantánea',
  countsLine: '{newPages} · {changedPages} para revisar · {unchanged} sin cambios',
  importAlreadyDiscarded: 'Esta importación ya se descartó.',
  confirmLabel: 'Confirmar importación',
  unchangedKeepCount:
    'one:documento sin cambios conserva su página|many:documentos sin cambios conservan sus páginas|other:documentos sin cambios conservan sus páginas',
  confirmBody:
    '¿Aplicar esta importación para todos en {company}? Se aprobarán como revisión 1: {newPages}. Quedarán pendientes de revisión: {changedPages}. Además, {unchanged}. Se retiran las sugerencias de importación anteriores para estas páginas.',
  applying: 'Aplicando…',
  applyImport: 'Aplicar importación',
  chooseAnother: 'Elegir otro archivo',
  allCurrent: 'Todo lo de esta instantánea ya está al día.',
  importApplied: 'Importación aplicada.',
  appliedSummary:
    'Creadas: {pages} · pendientes de revisión: {changes} · sin cambios: {unchanged}.',
  appliedIndexing:
    'Las páginas nuevas se podrán buscar en el chat cuando termine la indexación. Preparación de fuentes muestra el progreso.',
  openPages: 'Abrir páginas',
  reviewChanges: 'Revisar {changes}',
  checkIndexing: 'Comprobar el progreso de indexación',
  sendSnapshotFailed: 'No pudimos enviar esta instantánea. Inténtalo de nuevo.',
  openStagedFailed: 'No pudimos abrir esta importación preparada.',
  applyUnconfirmed:
    'No pudimos confirmar si se aplicó la importación. Comprueba Páginas antes de volver a intentarlo.',
  applyFailed: 'No pudimos aplicar esta importación.',
  importHeading: 'Importar páginas del repositorio',
  backToPages: 'Volver a las páginas',
  importLead:
    'Crea una instantánea con {command} y luego elige el archivo. Verás cada documento y lo que cambiaría antes de guardar nada.',
  snapshotFileLabel: 'Archivo de instantánea de conocimiento',
  readingSnapshot: 'Leyendo la instantánea…',
  openingStaged: 'Abriendo la importación preparada…',
  chooseSnapshot: 'Elegir archivo de instantánea',
  factOrigin: 'Origen',
  factContents: 'Contenido',
  importOnlyListed: 'Solo se importan los documentos que aparecen aquí.',
  importRepositoryAuthoritative:
    'El repositorio sigue siendo la fuente de referencia; los documentos modificados se convierten en sugerencias para revisar.',
  overviewReviewChanges: 'Revisar cambios',
  overviewConnectAgents: 'Conectar agentes externos',
  overviewEyebrow: 'Un conocimiento compartido',
  overviewTitle: '{company}, en contexto.',
  overviewLeadFallback:
    'El conocimiento de tu empresa empieza con el contexto que compartes. Construye con tu equipo una visión común de tu negocio.',
  overviewBody:
    'El contexto de la empresa y el material de origen dan a Poneva un punto de partida, no todo lo que hay que saber sobre {company}. Sigue ampliando este conocimiento a medida que evoluciona tu negocio.',
  overviewAskPrompt: '¿Qué sabes de nuestra empresa y qué sería útil añadir?',
  overviewAsk: 'Preguntar sobre {company}',
  overviewAddSources: 'Añadir fuentes',
  contextEyebrow: 'Lo que da contexto a las respuestas',
  contextTitle: 'El negocio detrás de la pregunta.',
  contextBody:
    'Las fuentes web explican la cara pública del negocio. Las notas de la empresa añaden su terminología, sus prioridades y su forma de trabajar.',
  contextPrompt:
    'Ayúdame a aclarar las prioridades de la empresa y las preferencias de trabajo que debemos recordar.',
  contextAction: 'Ampliar nuestro conocimiento',
  learnEyebrow: 'Margen para aprender',
  learnTitle: 'Empieza por lo que importa ahora.',
  learnBody:
    'Aporta material de origen o aclara cómo trabaja tu empresa. Poneva puede sugerir cambios duraderos para que los revises.',
  learnPrompt:
    'Según el conocimiento que ya tenemos de la empresa, ¿qué información importante falta para el trabajo que queremos hacer?',
  learnAction: 'Hablar de qué sería útil',
  canvasEmptyTitle: 'Un poco de contexto ayuda mucho.',
  canvasEmptyBody:
    'El perfil de tu empresa es el punto de partida. Añade material de origen y notas revisadas para ayudar a Poneva a entender tu trabajo.',
  pageEyebrow: 'Espacio de trabajo de {company}',
  pageTitle: 'Conocimiento de la empresa',
  pageDescription: 'Las fuentes y el conocimiento detrás del trabajo de Poneva.',
  tabOverview: 'Resumen',
  tabPages: 'Páginas',
  tabSources: 'Fuentes',
  tabReview: 'Para revisar',
  proposalApproved: 'Contexto de la empresa aprobado',
  proposalDismissed: 'Sugerencia descartada',
  proposalRemoval: 'Eliminación propuesta',
  proposalCorrection: 'Corrección propuesta',
  proposalContext: 'Contexto de la empresa propuesto',
  proposalCurrent: 'Conocimiento actual',
  proposalFactGone:
    'El dato guardado ya no está disponible. Actualiza el conocimiento de la empresa antes de revisar esta eliminación.',
  proposalReviewFallback: 'Revisa el contexto de la empresa propuesto.',
  proposalNotSaved: 'Aún no se ha guardado. Las fuentes originales no cambian.',
  proposalWaiting: 'Pendiente de revisión · un publicador decide en su Bandeja de entrada',
  proposalSaving: 'Guardando…',
  proposalApproveRemoval: 'Aprobar eliminación',
  proposalApproveClarification: 'Aprobar aclaración',
  factLabel: 'Dato de la empresa',
  factEyebrow: 'Dato · Todos en {company}',
  factSuggestCorrection: 'Sugerir una corrección',
  factAskPrompt: 'Ayúdame a entender o aclarar este contexto de la empresa guardado: «{content}»',
  factAsk: 'Preguntar sobre esto',
  companyContextHeading: 'Contexto de la empresa',
  companyContextPrompt:
    'Quiero aclarar el conocimiento de nuestra empresa. Ayúdame a revisar lo que sabemos y a proponer una actualización.',
  companyContextEmpty:
    'Aún no hay notas aprobadas. Empieza una conversación sobre tu empresa o añade material de origen abajo.',
  refineInChat: 'Pulir en el chat',
  reviewPanelLabel: 'Cambios de conocimiento para revisar',
  suggestedUpdatesHeading: 'Cambios sugeridos',
  suggestedUpdatesIntro:
    'Sugerencias de tus conversaciones. Tú decides qué pasa a formar parte del conocimiento duradero de tu empresa.',
  reviewEmptyTitle: 'No hay nada pendiente de tu revisión.',
  reviewEmptyBody:
    'Cuando Poneva sugiera un cambio en el conocimiento de tu empresa, lo encontrarás aquí. Los cambios duraderos siempre necesitan tu aprobación.',
  reviewEmptyPrompt:
    'Ayúdame a revisar el conocimiento de nuestra empresa y sugiere qué sería útil aclarar a continuación.',
  inclusionPendingApproval: 'Cambio de inclusión en el conocimiento enviado para su aprobación.',
  sourcesFileIncluded: 'Archivo incluido en la búsqueda de conocimiento para su audiencia actual.',
  sourcesAddFailed: 'No se pudo añadir esta fuente.',
  sourcesHeading: 'El material detrás de las respuestas.',
  sourcesIntro:
    'Poneva busca en todo el material de origen, no solo en el resumen. Conserva los originales, mira qué está listo y elige qué informa tus respuestas.',
  addSourceHeading: 'Añade material de tu empresa',
  addSourceIntro:
    'Las fuentes que subes quedan privadas en tu Biblioteca e informan tus propias respuestas. Elige Compartir cuando quieras ponerlas a disposición de tus compañeros.',
  uploadSource: 'Subir una fuente',
  addSourcePrompt:
    'Ayúdame a añadir una declaración de la empresa como fuente interna compartida. Pregúntame qué quiero registrar y no inventes contenido. Los cambios duraderos en el conocimiento de la empresa siguen necesitando mi aprobación.',
  addThroughChat: 'Añadir desde el chat',
  addingSource: 'Añadiendo…',
  addToKnowledge: 'Añadir al conocimiento',
  uploadFormats: 'TXT, Markdown, CSV y JSON · Hasta 5 MB por archivo',
  sourceExcluded: 'Excluida de las respuestas',
  sourcePreparationFailed: 'Error en la preparación',
  sourcePreparing: 'Preparando para la búsqueda',
  sourceWaiting: 'Pendiente de preparación',
  sourceReadinessUnknown: 'Estado de preparación no disponible',
  sourceRetryQueued: 'Preparación en cola. El estado se actualizará cuando termine.',
  sourceIncludedNotice: 'Fuente incluida. Poneva la preparará para la búsqueda.',
  sourceExcludedNotice: 'Excluida de las respuestas. La fuente original se conserva.',
  sourceUpdateFailed: 'No se pudo actualizar esta fuente.',
  sourceOriginalMaterial: 'Material de origen original',
  sourceDiscuss: 'Comentar en el chat',
  sourceDiscussPrompt: 'Ayúdame a entender o aclarar «{title}».',
  sourceExclude: 'Excluir de las respuestas',
  sourceInclude: 'Incluir en las respuestas',
  sourcesLoadFailed: 'No pudimos cargar tus fuentes.',
  sourceLibraryLabel: 'Biblioteca de fuentes de la empresa',
  sourceListCaption: 'Fuentes originales · incluidas y excluidas',
  sourceSearchLabel: 'Buscar en las fuentes de la empresa',
  sourceSearchPlaceholder: 'Busca en tus fuentes…',
  sourcesFinding: 'Buscando tus fuentes…',
  sourcePagesLabel: 'Páginas de fuentes',
  sourceRange: '{from}–{to} de {count}',
  sourceCount: 'one:fuente|many:fuentes|other:fuentes',
  sourcePrevious: 'Anterior',
  sourceNext: 'Siguiente',
  sourceNoMatchTitle: 'No hay fuentes que coincidan.',
  sourceNoMatchBody: 'Prueba con otra frase o con el nombre de una fuente.',
  sourceEmptyTitle: 'Da a tus preguntas un mejor punto de partida.',
  sourceEmptyBody:
    'Añade documentos de la empresa, datos de producto o notas de trabajo. Poneva puede usar todo el material de origen en conversaciones y Skills.',
  indexCheckFailed: 'No pudimos comprobar la preparación de las fuentes.',
  indexRetryQueued:
    'Las entradas de conocimiento fallidas están en cola para su preparación. Tu material de origen no cambia.',
  indexQueueFailed: 'No pudimos poner en cola la preparación. Inténtalo de nuevo.',
  indexPreparing: 'Preparando nuevo conocimiento para tus conversaciones…',
  indexAttention: 'Parte del conocimiento necesita atención.',
  queuing: 'Poniendo en cola…',
  retryPreparation: 'Reintentar preparación',
  sourceKindStatement: 'Declaración de la empresa',
  sourceKindWebsite: 'Sitio web',
  sourceKindDocument: 'Documento',
  factAnswers: 'one:respuesta|many:respuestas|other:respuestas',
  factUsedThisWeek: 'Usado en {answers} esta semana',
  factLastUsed: 'último uso: {when}',
  factToday: 'hoy',
  factYesterday: 'ayer',
  factImpact: 'Este cambio afecta a un dato usado en {answers} esta semana.',
  factCorrectionAbout: 'Sobre este dato de la empresa: «{content}» ({link})',
  factCorrectionOutdated: 'Esto está desactualizado:',
  sourceCanvasRecorded: 'Material de origen registrado',
  sourceCanvasNotIncluded:
    'No se incluye en el conocimiento de la empresa. El original se conserva como referencia y aún puede usarse en una conversación concreta.',
  sourceCanvasOpenOriginal: 'Abrir fuente original',
  sourceCanvasUnavailable: 'El contenido de la fuente no está disponible.',
  sourceCanvasDiscussPrompt: 'Ayúdame a entender o aclarar «{title}».',
  sourceCanvasDiscuss: 'Comentar esta fuente',
  sourceCanvasCorrectionNote:
    'Una corrección pasa a ser contexto de la empresa propuesto. La fuente registrada no cambia.',
  contextCanvasEyebrow: 'Contexto de la empresa disponible',
  contextCanvasTitle: 'El conocimiento detrás de esta conversación.',
  contextCanvasBody:
    'Conocimiento aprobado y el material de origen que ha añadido tu empresa. Disponible en el chat y en Skills.',
  contextCanvasOpen: 'Abrir Conocimiento',
};

export default es;
